const getElementExceedingPixels = (element) => {
  const rect = element.getBoundingClientRect();

  const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
  const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

  let exceedingPixels = 0;

  if (rect.top < 0) {
    exceedingPixels += Math.abs(rect.top);
  }

  if (rect.left < 0) {
    exceedingPixels += Math.abs(rect.left);
  }

  if (rect.bottom > viewportHeight) {
    exceedingPixels += rect.bottom - viewportHeight;
  }

  if (rect.right > viewportWidth) {
    exceedingPixels += rect.right - viewportWidth;
  }

  return exceedingPixels;
}

export const positioning = (
  tooltip?: HTMLElement,
  parent?: HTMLElement
): void => {
  if (!tooltip || !parent) {
    return;
  }

  const span = parent.querySelector(":scope > span") as HTMLElement;
  if (!span) {
    return;
  }

  const spanRect = span.getBoundingClientRect();

  tooltip.style.display = "block";
  tooltip.style.position = "fixed";

  const arrowWidth = 15;
  const left = spanRect.left - tooltip.offsetWidth / 2 + arrowWidth / 2;
  const tooltipHeight = tooltip.offsetHeight;
  const top = spanRect.top - tooltipHeight - 10;

  tooltip.style.left = `${Math.max(left, 0)}px`;
  tooltip.style.top = `${Math.max(top, 0)}px`;

  const exceedingPixels = getElementExceedingPixels(tooltip);

  if (exceedingPixels > 0) {
    const newLeft = `${Math.max(left, 0) - exceedingPixels}px`;
    tooltip.style.left = newLeft;

    const arrow = tooltip.querySelector('.arrow') as HTMLElement;

    arrow.style.transform = `translateX(${exceedingPixels}px)`
  }
};

export const hideToolTips = (): void => {
  document.querySelectorAll(".tooltip").forEach((el: HTMLElement) => {
    el.style.display = "none";
  });
};
